export default __webpack_public_path__ + "static/4-4d80d958618e2af821acbb38452aceb7.jpeg";